export const InvitationExpiredTime = 7 * 24 * 60 * 60 * 1000;

export enum ReconfirmInvitationType {
  Reconfirm = 'Reconfirm',
  Sent = 'Sent',
  Claimed = 'Claimed',
  PasswordSent = 'PasswordSent',
}

export const InvitationCategories = [
  { id: 'Organization', label: 'Organization' },
  { id: 'School', label: 'School' },
  { id: 'Company', label: 'Company' },
  { id: 'Brand', label: 'Brand' },
  { id: 'Trademark', label: 'Trademark' },
];
